import * as React from "react";

const CarInGarageIconSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#F8FAFC"
            d="M12.5 30.5q-.824 0-1.413-.587A1.93 1.93 0 0 1 10.5 28.5v-16q0-.824.587-1.413A1.93 1.93 0 0 1 12.5 10.5h16q.824 0 1.413.587.587.588.587 1.413v16q0 .824-.587 1.413a1.93 1.93 0 0 1-1.413.587zm0-2h16v-16h-16zm5-6a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712q0-.424.287-.712a.97.97 0 0 1 .713-.288q.424 0 .713.288.287.287.287.712 0 .424-.287.712a.97.97 0 0 1-.713.288m6 0a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712q0-.424.288-.712a.97.97 0 0 1 .712-.288q.424 0 .712.288.288.287.288.712 0 .424-.288.712a.97.97 0 0 1-.712.288m-10-2.9v6.6q0 .35.225.575T14.3 27h.4a.78.78 0 0 0 .575-.225.78.78 0 0 0 .225-.575V25h10v1.2q0 .35.225.575T26.3 27h.4a.78.78 0 0 0 .575-.225.78.78 0 0 0 .225-.575v-6.6l-1.65-4.8a1.25 1.25 0 0 0-.413-.575A1 1 0 0 0 24.8 14h-8.6a1 1 0 0 0-.637.225q-.288.225-.413.575zm2.65-1.6.7-2h7.3l.7 2zm-3.613-5.5v16zM15.5 23v-3h10v3z"
        ></path>
    </svg>
);

export default CarInGarageIconSVG;
